export default __webpack_public_path__ + "static/media/prev-not-clicked.bf322cdd.svg";